export const cvWidth = [1175, 1175, 950, 800, 800];

export const textSizes = [
  {
    titles: 20,
    texts: 15,
    internalTitle: 16,
    internalText: 14,
    ratedSectionStar: 24,
    sectionText: 15,
    letterSize: 14,
  },
  {
    titles: 20,
    texts: 15,
    internalTitle: 16,
    internalText: 14,
    ratedSectionStar: 22,
    sectionText: 15,
    letterSize: 14,
  },
  {
    titles: 18,
    texts: 14,
    internalTitle: 14,
    internalText: 13,
    ratedSectionStar: 20,
    sectionText: 13,
    letterSize: 13,
  },
  {
    titles: 17,
    texts: 14,
    internalTitle: 13,
    internalText: 12,
    ratedSectionStar: 15,
    sectionText: 12,
    letterSize: 13,
  },
  {
    titles: 17,
    texts: 14,
    internalTitle: 13,
    internalText: 12,
    ratedSectionStar: 15,
    sectionText: 12,
    letterSize: 13,
  },
];

export const downloadButtons = [
  {
    height: 40,
    width: 156,
    radius: 15,
    size: 12,
  },
  {
    height: 40,
    width: 156,
    radius: 15,
    size: 12,
  },
  {
    height: 34,
    width: 117,
    radius: 10,
    size: 12,
  },
  {
    height: 28,
    width: 95,
    radius: 10,
    size: 11,
  },
  {
    height: 28,
    width: 95,
    radius: 10,
    size: 11,
  },
];
